import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import FormControlLabel from '@mui/material/FormControlLabel';
import Grid from '@mui/material/Grid';
import { useTranslation } from 'react-i18next';
import { ChangeEvent, useState } from 'react';
import { useDispatch } from 'react-redux';
import { updateTermsAndConditions } from '../../store/termsAndConditions/actions/updateTermsAndConditions';
import { homeScreenStyles } from './homeScreenStyles';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useTheme } from '@mui/material/styles';
import {
  ASSETS_PATH,
  VESTING_1_END_DATE,
  VESTING_2_END_DATE
} from '../../services/endpoints';
import { CountdownVesting } from '../CountdownVesting/CountdownVesting';
import { Typography, useMediaQuery } from '@mui/material';

export const HomeScreen = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const classes = homeScreenStyles(theme);
  const dispatch = useDispatch();
  const documentPath = `${ASSETS_PATH}/documents/terms_and_conditions.pdf`;
  const vesting1Countdown = VESTING_1_END_DATE;
  const vesting2Countdown = VESTING_2_END_DATE;
  const isDownSm = useMediaQuery(theme.breakpoints.down('sm'));
  const vestingContractCountdowns = [vesting1Countdown, vesting2Countdown];
  const [checked, setChecked] = useState(false);
  const variantTitle = isDownSm ? 'h4' : 'h3';
  const variantSubitle = isDownSm ? 'subtitle1' : 'h5';
  const variantTermsAndConditions = isDownSm ? 'body2' : 'body1';

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
  };
  const handleSubmit = () => {
    dispatch(updateTermsAndConditions(true));
  };
  return (
    <>
      <Grid container sx={classes.container}>
        <Grid
          item
          container
          direction='column'
          justifyContent='center'
          xs={12}
          alignItems='center'
          sx={classes.titleContainer}
        >
          <Grid item>
            <Typography variant={variantTitle}>
              {t('vesting.home.title')}
            </Typography>
          </Grid>
          <Grid item>
            <Typography variant={variantSubitle} sx={classes.subtitle}>
              {t('vesting.home.subtitle')}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          item
          container
          direction={{ xs: 'column', sm: 'row' }}
          sx={classes.countdownContainer}
          wrap='nowrap'
          rowSpacing={2}
        >
          {vestingContractCountdowns.map((endDate: string, index: number) => (
            <Grid
              item
              xs={6}
              sx={classes.itemCard}
              key={`vestingCountdownItem${index}`}
            >
              <CountdownVesting
                countdownVestingIndex={index}
                endDate={endDate}
                key={`vestingCountdownComponent${index}`}
              />
            </Grid>
          ))}
        </Grid>
        <Grid item justifyContent='center' sx={classes.form}>
          <FormGroup sx={classes.termsAndButton}>
            <FormControlLabel
              sx={classes.termsConditions}
              control={
                <Checkbox
                  checked={checked}
                  onChange={handleChange}
                  inputProps={{ 'aria-label': 'Terms&Conditions' }}
                />
              }
              label={
                <Box sx={classes.termsConditionsText}>
                  <Typography variant={variantTermsAndConditions}>
                    {t('vesting.countdown_page.terms_conditions.text')}
                  </Typography>
                  <Link
                    color='primary'
                    href={documentPath}
                    underline='hover'
                    sx={classes.link}
                    target='_blank'
                  >
                    <Typography variant={variantTermsAndConditions}>
                      {t('vesting.countdown_page.terms_conditions.link')}
                    </Typography>
                  </Link>
                </Box>
              }
            />

            <Button
              disabled={!checked}
              variant='contained'
              onClick={handleSubmit}
              endIcon={<ArrowForwardIcon />}
              sx={classes.button}
            >
              {t('vesting.countdown_page.button.stake')}
            </Button>
          </FormGroup>
        </Grid>
      </Grid>
    </>
  );
};
